/**
 * Generated by orval 🍺
 * Do not edit manually.
 * lcm-microservice
 * OpenAPI spec version: 1.0.0
 */
export const MetaFormatEnum = {
    SQUARE: 'SQUARE',
    CAROUSEL: 'CAROUSEL',
    CUSTOM: 'CUSTOM',
};
